export interface Permission {
  adminOrg?: string[]
  editOrg?: string[]
  readOrg?: string[]
  publicationLevel?: PublicationLevel
  level?: PermissionLevel
  ownerOrg?: string
}

export type PublicationLevel =
  'PUBLIC' |
  'PROJECT' |
  'WORKSPACE' |
  'PERMISSION'
export const PUBLICATION_LEVEL_DEF: EnumDef = Object.freeze({
  id: 'jps-publication_level',
  c: {
    PUBLIC: {
      l: {
        ja: '公開',
        en: 'Public'
      },
      d: {}
    },
    PROJECT: {
      l: {
        ja: 'プロジェクト',
        en: 'Project'
      },
      d: {}
    },
    WORKSPACE: {
      l: {
        ja: 'ワークスペース内',
        en: 'Workspace'
      },
      d: {}
    },
    PERMISSION: {
      l: {
        ja: '関係者限定',
        en: 'Private'
      },
      d: {}
    }
  }
})
export type PermissionLevel =
  'ADMIN' |
  'EDIT' |
  'READ' |
  'PUBLIC' |
  'NONE'
export const PERMISSION_LEVEL_DEF: EnumDef = Object.freeze({
  id: 'jps-permission_level',
  c: {
    ADMIN: {
      l: {
        ja: '管理権限',
        en: 'Administrator'
      },
      d: {}
    },
    EDIT: {
      l: {
        ja: '編集権限',
        en: 'Editor'
      },
      d: {}
    },
    READ: {
      l: {
        ja: '閲覧権限',
        en: 'Read Only'
      },
      d: {}
    },
    PUBLIC: {
      l: {
        ja: '公開閲覧権限',
        en: 'Public Read Only'
      },
      d: {}
    },
    NONE: {
      l: {
        ja: '権限無し',
        en: 'Not Accessible'
      },
      d: {}
    }
  }
})
